import React from 'react';
import { SelectPicker, Stack } from 'rsuite';

interface TaxFiltersProps {
  data: {
    options: { name?: string; value?: string }[];
    selectedValue?: string;
    onSelect: (value?: string) => void;
  }[];
}

export const TaxFilters: React.FC<TaxFiltersProps> = ({ data }) => {
  return (
    <Stack style={{ display: 'flex', gap: '16px' }}>
      {data?.map((item, index) => (
        <Stack key={index}>
          <SelectPicker
            labelKey="name"
            valueKey="value"
            data={item?.options}
            searchable={false}
            value={item?.selectedValue}
            onSelect={(value) => item?.onSelect(value)}
            menuAutoWidth={false}
            menuMaxHeight={240}
            cleanable={false}
            style={{ maxWidth: 200 }}
          />
        </Stack>
      ))}
    </Stack>
  );
};
